import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { WarehouseFilterOption } from 'src/app/searchFilters/warehouse-filter-option';
import { AppSettings } from 'src/app/shared/App-Settings';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  GetWarehouseCollection(currentPage: number, pageSize: number, order: string, sortby: string, filter: WarehouseFilterOption) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}WarehousesCollection`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.title) {
      url = url + '&Title=' + filter.title;
    }
    if(filter.createdDate){
      var pipe = new DatePipe('en-US');
      url = url + '&CreatedDate=' + pipe.transform(filter.createdDate, "MM-dd-yyyy");
    }

    if(filter.isActive)
      url = url + '&IsActive=' + filter.isActive;


    return this.httpClient.get<any>(url, httpOptions);
  }

  GetWarehouseList() {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}WarehousesCollection/getAll`;
    return this.httpClient.get<any>(url, httpOptions);
  }


  GetWarehouseListByIds(warehouseIds) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}WarehousesCollection/getAll`;
    if(warehouseIds){
      url = url + "?WarehouseIds="+warehouseIds;
    }
    return this.httpClient.get<any>(url, httpOptions);
  }

  Add(model, file): Observable<any> {
    let accessToken = this.auth.getAccessToken();

    const httpOptions = {
      headers: new HttpHeaders({

        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let formData = new FormData();

    formData.append("file", file);

    for (var key in model) {
      if (model.hasOwnProperty(key)) {
        var val = model[key];
        formData.append(key, val);
      }
    }
    let url = `${apiUrl}Warehouses`;
    return this.httpClient.post<any>(url, formData, httpOptions);
  }

  getWarehouseById(id: number): Observable<any> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}Warehouses/${id}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  Update(id, model, file): Observable<any> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({

        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let formData = new FormData();

    formData.append("file", file);

    for (var key in model) {
      if (model.hasOwnProperty(key)) {
        var val = model[key];
        formData.append(key, val);
      }
    }

    let url = `${apiUrl}Warehouses/${id}`;
    return this.httpClient.put<any>(url, formData, httpOptions);
  }

  Delete(id) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}Warehouses/${id}`;
    return this.httpClient.delete<any>(url, httpOptions);
  }
}
